module.exports = __webpack_public_path__ + "img/shangwu.da034510.png";